//
//
//
//
//
//

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		brandLink: {},
		brandLogo: {
			default: require('../../images/dummy_image.jpg'),
		},
	},

	computed: {},

	watch: {},

	methods: {
		mouseover: function () {
			this.show = true;
		},
		mouseleave: function () {
			this.show = false;
		},
	},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/BrandGridItem.vue